/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'confluence-table-tree.column.contributors': 'Beitragende',
  'confluence-table-tree.column.last-modified': 'Letzte Änderung',
  'confluence-table-tree.column.title': 'Name',
  'confluence-table-tree.could-not-load': 'Konnte nicht geladen werden',
  'confluence-table-tree.could-not-load-contributors': 'Beitragende konnten nicht geladen werden',
  'confluence-table-tree.create-child-page': 'Untergeordnete Seite erstellen',
  'confluence-table-tree.create-page': 'Seite erstellen',
  'confluence-table-tree.default.page.title': 'Ohne Namen',
  'confluence-table-tree.default.show-all-pages-button.label': 'Weitere Seiten anzeigen',
  'confluence-table-tree.draft.lozenge': 'ENTWURF',
  'confluence-table-tree.draft.tooltip': 'Entwürfe können nur von Ihnen gesehen werden.',
  'confluence-table-tree.drafts-toggle.label': 'Entwürfe anzeigen',
  'confluence-table-tree.edit': 'Bearbeiten',
  'confluence-table-tree.edit-in-confluence': 'In Confluence bearbeiten',
  'confluence-table-tree.empty.description':
    'Erstellen Sie Besprechungsnotizen, Produktanforderungen, Entscheidungen und andere Inhalte, damit dieser Bereich sich füllt.',
  'confluence-table-tree.empty.title': 'Es gibt hier nichts, außer Potenzial',
  'confluence-table-tree.error.description':
    'Wir können diese Seiten nicht anzeigen. Bitte versuchen Sie es später erneut.',
  'confluence-table-tree.error.row': 'Seiten konnten nicht geladen werden.',
  'confluence-table-tree.error.title': 'Das ist seltsam …',
  'confluence-table-tree.friendly-when-created': 'Erstellt',
  'confluence-table-tree.friendly-when-updated': 'Aktualisiert',
  'confluence-table-tree.share.copied': 'In Zwischenablage kopiert',
  'confluence-table-tree.share.copy-button': 'Kopieren',
  'confluence-table-tree.share.subtitle': 'Link teilen',
  'confluence-table-tree.share.title': 'Seite teilen',
  'confluence-table-tree.share.tooltip': 'Teilen',
  'confluence-table-tree.view-profile': 'Profil anzeigen',
};
